import React ,{useEffect}from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Switch,
  FormControlLabel,
  IconButton,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SharingSetting = ({ open, onClose, isShareMember, setIsShareMember, position }) => {
  const handleToggle = () => {
    setIsShareMember((prev) => !prev);
  };
  useEffect(() => {
    if (position?.share_with_all_team_members !== undefined) {
      setIsShareMember(position.share_with_all_team_members === 1); 
    }
  }, [position?.share_with_all_team_members, setIsShareMember]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: "12px" } }}>
      <Stack p={1} spacing={2} position="relative">
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 30,
            color: "grey.600",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle>
          <Typography variant="h5" fontWeight="bold">
            Sharing settings
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Typography variant="h6" color="textSecondary">
            Share this job with other team members.
          </Typography>

          <Stack spacing={1} mt={2}>
            <FormControlLabel
              control={<Switch checked={isShareMember} onChange={handleToggle} />} label="Share with the entire team"
            />

          </Stack>
        </DialogContent>
      </Stack>
    </Dialog>
  );
};

export default SharingSetting;
